var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AdyenMerchantPanel',{attrs:{"title-key":"smoothrPay.payouts.title","subtitle-key":"smoothrPay.payouts.subtitle","select-merchant-key":"smoothrPay.payouts.selectMerchant","component":_vm.payoutsOverview}})
}
var staticRenderFns = []

export { render, staticRenderFns }